export const translations = {
  en: {
    nav: {
      home: "Home",
      services: "Services",
      about: "About",
      contact: "Contact",
      getInTouch: "Get In Touch"
    },
    hero: {
      title: "Trusted Partner for Qatar's Business Success",
      subtitle: "Transform your business with strategic consulting and comprehensive commercial services tailored to your success",
      ctaPrimary: "Get Started",
      ctaSecondary: "Our Services"
    },
    stats: {
      projects: "Projects Completed",
      clients: "Happy Clients",
      experience: "Years Experience",
      satisfaction: "Client Satisfaction"
    },
    services: {
      title: "Our Services",
      subtitle: "Comprehensive solutions tailored to your business needs",
      learnMore: "Learn More",
      items: {
        management: {
          title: "Management Consultancy",
          description: "Strategic planning, organizational development, and performance optimization to drive sustainable business growth."
        },
        commercial: {
          title: "Commercial Services",
          description: "Comprehensive commercial solutions including business setup, licensing, and regulatory compliance management."
        },
        strategy: {
          title: "Business Strategy",
          description: "Data-driven insights and strategic frameworks to help you make informed decisions and achieve competitive advantage."
        },
        financial: {
          title: "Financial Advisory",
          description: "Expert financial planning, analysis, and advisory services to optimize your business financial performance."
        },
        operations: {
          title: "Operations Management",
          description: "Streamline your operations with proven methodologies and best practices for efficiency and productivity."
        },
        hr: {
          title: "HR Consulting",
          description: "Human resource management solutions including recruitment, training, and organizational development."
        },
        service7: {
          title: "Government Transactions Clearance",
          description: "Expert handling of all government-related transactions, documentation, and regulatory clearances in Qatar."
        },
        service8: {
          title: "Company Establishment",
          description: "Complete support for establishing Qatari and foreign-invested companies with full legal and regulatory compliance."
        },
        service9: {
          title: "Administrative Planning",
          description: "Comprehensive administrative planning services to optimize organizational structure and workflow efficiency."
        },
        service10: {
          title: "Financial Planning",
          description: "Strategic financial planning and budgeting services to ensure long-term financial stability and growth."
        },
        service11: {
          title: "Economic Feasibility Studies",
          description: "In-depth economic analysis and feasibility studies to evaluate investment opportunities and market potential."
        },
        service12: {
          title: "Financial Feasibility Studies",
          description: "Detailed financial feasibility assessments to determine project viability and return on investment."
        },
        service13: {
          title: "Financial Auditing",
          description: "Professional financial auditing services ensuring compliance, accuracy, and transparency in financial reporting."
        },
        service14: {
          title: "Financial Analysis",
          description: "Comprehensive financial analysis and reporting to support strategic decision-making and business planning."
        },
        service15: {
          title: "Commercial Brokerage",
          description: "Professional brokerage services connecting businesses with opportunities and facilitating commercial transactions."
        }
      }
    },
    about: {
      title: "About Enjaz",
      subtitle: "Enjaz Commercial Services and Management Consultancy",
      companyProfile: "Enjaz Commercial Services and Management Consultancy is a Qatari limited liability company, specialized in providing integrated solutions in commercial services, administrative and economic consultancy. The company was established to be a trusted partner for entrepreneurs, startups, and established companies, by offering a package of services designed to meet the needs of the Qatari and regional market.",
      philosophy: "At Enjaz, we believe that success in the business sector requires a clear vision, precise planning, and smart execution. Therefore, we work to empower our clients through professional consultations that support the sustainability of their businesses and help them make effective strategic decisions.",
      description: "Enjaz Commercial Services and Management Consultancy is a trusted partner for businesses seeking excellence in Qatar. We combine deep industry expertise with innovative approaches to deliver tailored solutions that drive measurable results.",
      mission: {
        title: "Our Mission",
        text: "To empower businesses with world-class commercial services and strategic consulting that creates lasting value and competitive advantage."
      },
      vision: {
        title: "Our Vision",
        text: "To be a leader in providing commercial and consulting services in Qatar and the region, through commitment to professionalism, transparency, and delivering added value to our clients."
      },
      coreServices: {
        title: "Our Core Services",
        items: [
          "Preparation of economic studies and feasibility studies",
          "Providing administrative and commercial consultancy",
          "Development of business plans and growth strategies",
          "Company registration and establishment requirements",
          "Solutions for improving operational efficiency",
          "Commercial translation and professional reports",
          "Financial auditing and compliance services",
          "Financial analysis and reporting"
        ]
      },
      values: {
        excellence: {
          title: "Excellence",
          description: "We strive for excellence in every service we deliver"
        },
        integrity: {
          title: "Integrity",
          description: "We conduct business with the highest ethical standards"
        },
        innovation: {
          title: "Innovation",
          description: "We embrace innovative solutions to solve complex challenges"
        },
        partnership: {
          title: "Partnership",
          description: "We build long-term relationships based on trust and results"
        }
      }
    },
    contact: {
      title: "Get In Touch",
      subtitle: "Let's discuss how we can help your business grow",
      email: "Email",
      phone: "Phone",
      office: "Office",
      pobox: "P.O. Box",
      country: "Qatar",
      form: {
        name: "Name",
        email: "Email",
        phone: "Phone",
        message: "Message",
        submit: "Send Message",
        successMessage: "Thank you for your message! We will get back to you soon."
      }
    },
    footer: {
      tagline: "Trusted Partner for Qatar's Business Success",
      quickLinks: "Quick Links",
      contact: "Contact",
      copyright: "Enjaz Commercial Services and Management Consultancy. All rights reserved."
    },
    clients: {
      title: "Government Services We Handle",
      subtitle: "Expert assistance with transactions and procedures across Qatar's government entities",
      organizations: {
        commerce: "Ministry of Commerce and Industry",
        interior: "Ministry of Interior",
        labor: "Ministry of Labor",
        justice: "Ministry of Justice",
        municipality: "Ministry of Municipality",
        finance: "Ministry of Finance",
        health: "Ministry of Health",
        foreign: "Ministry of Foreign Affairs",
        chamber: "Qatar Chamber of Commerce",
        tax: "General Tax Authority",
        customs: "General Authority of Customs",
        embassies: "Embassies and Diplomatic Missions"
      },
      additional: "We provide professional services for all government transactions, documentation, and procedures across Qatar"
    }
  },
  ar: {
    nav: {
      home: "الرئيسية",
      services: "الخدمات",
      about: "من نحن",
      contact: "اتصل بنا",
      getInTouch: "تواصل معنا"
    },
    hero: {
      title: "شريكك الموثوق لتحقيق النجاح المؤسسي في قطر",
      subtitle: "نُحوّل رؤيتك إلى واقع ملموس من خلال استشارات استراتيجية متقدمة وخدمات تجارية متكاملة مُصمّمة لتحقيق التميز المؤسسي",
      ctaPrimary: "ابدأ معنا",
      ctaSecondary: "استكشف خدماتنا"
    },
    stats: {
      projects: "مشروع مُنجَز",
      clients: "عميل راضٍ",
      experience: "سنوات من الخبرة",
      satisfaction: "معدل رضا العملاء"
    },
    services: {
      title: "خدماتنا المتخصصة",
      subtitle: "حلول استراتيجية متكاملة مُصمّمة بعناية لتلبية متطلبات مؤسستكم",
      learnMore: "المزيد من التفاصيل",
      items: {
        management: {
          title: "الاستشارات الإدارية الاستراتيجية",
          description: "تخطيط استراتيجي متقدم وتطوير تنظيمي مؤسسي وتحسين الأداء التشغيلي لتحقيق النمو المستدام والتميز المؤسسي."
        },
        commercial: {
          title: "الخدمات التجارية المتكاملة",
          description: "حلول تجارية شاملة تتضمن تأسيس المنشآت والترخيص التجاري وإدارة الامتثال التنظيمي وفق أعلى المعايير المهنية."
        },
        strategy: {
          title: "استراتيجيات الأعمال المتقدمة",
          description: "رؤى استراتيجية مدعومة بتحليلات معمّقة وأطر عمل منهجية لاتخاذ قرارات مستنيرة وتحقيق تفوق تنافسي مستدام."
        },
        financial: {
          title: "الاستشارات المالية المتخصصة",
          description: "خدمات التخطيط المالي الاستراتيجي والتحليل المتعمق والاستشارات المتقدمة لتحسين الأداء المالي وتعزيز الربحية."
        },
        operations: {
          title: "إدارة العمليات التشغيلية",
          description: "تحسين وتبسيط العمليات التشغيلية من خلال منهجيات عالمية مُثبتة وأفضل الممارسات لتحقيق الكفاءة والإنتاجية القصوى."
        },
        hr: {
          title: "استشارات إدارة الموارد البشرية",
          description: "حلول إدارة رأس المال البشري المتكاملة تشمل الاستقطاب والتطوير المهني وبناء الهياكل التنظيمية الفعّالة."
        },
        service7: {
          title: "تخليص المعاملات الحكومية",
          description: "إدارة احترافية متخصصة لكافة المعاملات الحكومية والمستندات الرسمية والتصاريح التنظيمية في دولة قطر."
        },
        service8: {
          title: "تأسيس الشركات والمنشآت",
          description: "دعم شامل ومتكامل لتأسيس الشركات القطرية والاستثمارات الأجنبية مع ضمان الامتثال الكامل للأنظمة والتشريعات القانونية."
        },
        service9: {
          title: "التخطيط الإداري المؤسسي",
          description: "خدمات تخطيط إداري شاملة لتطوير الهيكل التنظيمي وتحسين كفاءة سير العمل وتعزيز الأداء المؤسسي."
        },
        service10: {
          title: "التخطيط المالي الاستراتيجي",
          description: "خدمات التخطيط المالي طويل المدى وإعداد الموازنات التقديرية لضمان الاستقرار المالي وتحقيق النمو المستدام."
        },
        service11: {
          title: "دراسات الجدوى الاقتصادية",
          description: "تحليل اقتصادي متعمق ودراسات جدوى شاملة لتقييم فرص الاستثمار وتحليل إمكانات السوق وقياس جدوى المشاريع."
        },
        service12: {
          title: "دراسات الجدوى المالية التفصيلية",
          description: "تقييمات مالية دقيقة ومفصّلة لتحديد الجدوى الاستثمارية للمشاريع وحساب العائد على الاستثمار والمخاطر المحتملة."
        },
        service13: {
          title: "التدقيق المالي والمحاسبي",
          description: "خدمات تدقيق مالي ومحاسبي احترافية وفق المعايير الدولية لضمان الامتثال والدقة والشفافية في التقارير المالية."
        },
        service14: {
          title: "التحليل المالي المتقدم",
          description: "تحليل مالي متعمق وإعداد تقارير تفصيلية لدعم القرارات الاستراتيجية وتطوير خطط الأعمال والتوسع المؤسسي."
        },
        service15: {
          title: "الوساطة التجارية المتخصصة",
          description: "خدمات وساطة تجارية احترافية تربط المؤسسات بفرص الأعمال الواعدة وتسهيل المعاملات التجارية وبناء الشراكات الاستراتيجية."
        }
      }
    },
    about: {
      title: "عن إنجاز",
      subtitle: "إنجاز للخدمات التجارية والاستشارات الإدارية",
      companyProfile: "شركة إنجاز للخدمات التجارية والاستشارات الإدارية هي شركة قطرية ذات مسؤولية محدودة، متخصصة في تقديم حلول استشارية متكاملة في مجالات الخدمات التجارية والاستشارات الإدارية والاقتصادية. تأسست الشركة لتكون شريكاً استراتيجياً موثوقاً لرواد الأعمال والمنشآت الناشئة والشركات القائمة، من خلال تقديم باقة متنوعة من الخدمات الاستشارية المتخصصة المُصممة بدقة لتلبية متطلبات السوق القطري والإقليمي.",
      philosophy: "نحن في \"إنجاز\" نؤمن بأن تحقيق التميز المؤسسي في قطاع الأعمال يتطلب رؤية استراتيجية واضحة، وتخطيطاً دقيقاً منهجياً، وتنفيذاً احترافياً متقناً. لذلك، نعمل على تمكين عملائنا من خلال استشارات مهنية متخصصة تدعم استدامة مؤسساتهم وتُمكّنهم من اتخاذ قرارات استراتيجية فعّالة ومدروسة.",
      description: "إنجاز للخدمات التجارية والاستشارات الإدارية هي شريك استراتيجي موثوق للمؤسسات الطموحة التي تسعى لتحقيق التميز والريادة في قطر. نجمع بين الخبرة الصناعية العميقة والمنهجيات الاستشارية المبتكرة لتقديم حلول مخصّصة تحقق نتائج قابلة للقياس وتضيف قيمة حقيقية لأعمالكم.",
      mission: {
        title: "رسالتنا",
        text: "تمكين المؤسسات من تحقيق التميز التشغيلي والنمو المستدام من خلال خدمات تجارية واستشارية عالمية المستوى تخلق قيمة مضافة حقيقية وتحقق تفوقاً تنافسياً مستداماً."
      },
      vision: {
        title: "رؤيتنا",
        text: "أن نكون الخيار الأول والشريك الاستراتيجي الأكثر موثوقية في تقديم الخدمات التجارية والاستشارات الإدارية في قطر والمنطقة، من خلال الالتزام الراسخ بالاحترافية والشفافية والتميز وتحقيق القيمة المضافة المستدامة لعملائنا."
      },
      coreServices: {
        title: "خدماتنا الأساسية المتخصصة",
        items: [
          "إعداد الدراسات الاقتصادية المتقدمة ودراسات الجدوى التفصيلية",
          "تقديم الاستشارات الإدارية والتجارية الاستراتيجية المتخصصة",
          "تطوير خطط الأعمال الشاملة واستراتيجيات النمو والتوسع",
          "تسجيل الشركات وتجهيز متطلبات التأسيس القانونية والتنظيمية",
          "تقديم حلول مبتكرة لتحسين الكفاءة التشغيلية والإنتاجية",
          "خدمات الترجمة التجارية المتخصصة وإعداد التقارير الاحترافية",
          "خدمات التدقيق المالي والمحاسبي وضمان الامتثال",
          "التحليل المالي المتقدم وإعداد التقارير المالية التفصيلية"
        ]
      },
      values: {
        excellence: {
          title: "التميز المؤسسي",
          description: "نسعى جاهدين لتحقيق أعلى معايير التميز في كل خدمة نقدمها"
        },
        integrity: {
          title: "النزاهة والشفافية",
          description: "نمارس أعمالنا وفق أعلى المعايير الأخلاقية والمهنية"
        },
        innovation: {
          title: "الابتكار والتطوير",
          description: "نتبنى الحلول المبتكرة والمنهجيات الحديثة لمواجهة التحديات المعقدة"
        },
        partnership: {
          title: "الشراكة الاستراتيجية",
          description: "نبني علاقات استراتيجية طويلة الأمد قائمة على الثقة المتبادلة والنتائج المُثبتة"
        }
      }
    },
    contact: {
      title: "تواصل معنا",
      subtitle: "دعنا نناقش معاً كيف يمكننا المساهمة في تطوير ونمو مؤسستكم",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      office: "المكتب",
      pobox: "صندوق البريد",
      country: "قطر",
      form: {
        name: "الاسم الكامل",
        email: "البريد الإلكتروني",
        phone: "رقم الهاتف",
        message: "رسالتك",
        submit: "إرسال الرسالة",
        successMessage: "شكراً لتواصلكم معنا! سيقوم فريقنا بالرد عليكم في أقرب وقت ممكن."
      }
    },
    footer: {
      tagline: "شريكك الموثوق لتحقيق النجاح المؤسسي في قطر",
      quickLinks: "روابط سريعة",
      contact: "اتصل بنا",
      copyright: "إنجاز للخدمات التجارية والاستشارات الإدارية. جميع الحقوق محفوظة."
    },
    clients: {
      title: "الجهات الحكومية التي نتعامل معها",
      subtitle: "مساعدة احترافية متخصصة في إدارة المعاملات والإجراءات لدى كافة الجهات الحكومية في دولة قطر",
      organizations: {
        commerce: "وزارة التجارة والصناعة",
        interior: "وزارة الداخلية",
        labor: "وزارة العمل",
        justice: "وزارة العدل",
        municipality: "وزارة البلدية",
        finance: "وزارة المالية",
        health: "وزارة الصحة العامة",
        foreign: "وزارة الخارجية",
        chamber: "غرفة قطر للتجارة والصناعة",
        tax: "الهيئة العامة للضرائب",
        customs: "الهيئة العامة للجمارك",
        embassies: "السفارات والبعثات الدبلوماسية"
      },
      additional: "نقدم خدمات احترافية متكاملة لإدارة جميع المعاملات الحكومية والمستندات الرسمية والإجراءات التنظيمية في كافة أنحاء دولة قطر"
    }
  }
};

export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};
